import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { SdrLabelModel } from '../../Models/Models/Instruments/SdrLabelModel';
import { SDRLabelQuery } from '../../Models/Domains/Investment/SDRLabelQuery';

declare var IS_RUNNING_IN_APP_POOL;

export class SDRLabelClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public post(query: SDRLabelQuery): Promise<Array<SdrLabelModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/SDRLabel/Post';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { query: query }

    return AjaxWrapper.post<Array<SdrLabelModel>, any>(url, data);
  }
  public get(): Promise<Array<SdrLabelModel>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/Instruments/SDRLabel/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = {}

    return AjaxWrapper.get<Array<SdrLabelModel>, any>(url, data);
  }
}

